import * as types from './types'

export default {
  [types.SET_USERS] (state, users) {
    state.users = users || []
  },
  [types.SET_ROLES] (state, roles) {
    state.roles = roles || []
  },
  [types.ADD_USER] (state, user) {
    state.users.push(user)
  },
  [types.DELETE_USER] (state, user) {
    state.users.splice(state.users.indexOf(user), 1)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js